import React, {useState} from "react";
import {Image} from "antd/lib";
import placeholder from "../../../images/placeholder.png"
import {RootStoreContext} from "../../../../../stores/root/root";
import {RootControllersContext} from "../../../../../controllers/root/root.controllers";
import {useRequiredLayers} from "../../../../../utils/context";

interface CatalogImagePreview {
    size: string
    scheme: boolean;
}

interface ProductImageProps extends CatalogImagePreview {
    sku: string;
    previews: CatalogImagePreview[];
    width: number;
    height: number;
}

function createUrl(generateUri: (uri: string, params: any, useDefaultServer?: boolean) => string, sku: string, preview: CatalogImagePreview) {
    return generateUri("/product_photos/" + preview.size + (preview.scheme ? "/schemes/" : "/photos/") + sku + (preview.scheme ? ".png" : ".jpg"), {}, true);
}

export const ProductImage: React.FC<ProductImageProps> = (props) => {

    const {sku, width, height, previews} = props;
    const [visible, setVisible] = useState(false);

    const {controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)

    return (
        <>
            <Image
                alt={sku}
                width={width}
                height={height}
                src={createUrl(loginController.generateUri, sku, props)}
                fallback={placeholder}
                onClick={() => setVisible(true)}
                preview={{ visible: false }}
            />
            <div style={{ display: 'none' }}>
                <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>
                    {previews.map(preview =>(
                        <Image
                            alt={sku}
                            width={width}
                            height={height}
                            src={createUrl(loginController.generateUri, sku, preview)}
                            fallback={placeholder}
                        />
                    ))}
                </Image.PreviewGroup>
            </div>
        </>

    )
}
